import { Typography } from '@gds/Typography/Typography';

import type { SubNavItemProps } from '../../Entities/Nav.entity';
import { TrackedLink } from '../TrackedLink/TrackedLink';
import { ImageSubNavItem } from './ImageSubNavItem/ImageSubNavItem';
import { StandardSubNavItem } from './StandardSubNavItem/StandardSubNavItem';

import styles from './SubNavItem.module.css';

export const SubNavItem: React.FC<SubNavItemProps> = ({
  subnavgroupitems,
  navHeading,
  navItemId,
  showAllLink,
  isNavMenuList,
  origin,
}) => {
  const { href: showAllHref, label: showAllLabel } = showAllLink || {};
  const canShowMoreLink = !!showAllHref;

  return (
    <>
      <ul
        aria-label={`${navHeading} menu`}
        data-test-id={`${navHeading}-menu-list`}
        className={styles.subNavListWrapper}
      >
        {subnavgroupitems.map(
          ({ label, image, imageAltTexts, link, description, date, rating, href, desc, logo }) => (
            <li
              key={`${navItemId}-${navHeading}-${label}`}
              className={`${image ? styles.imageList : styles.standardList}`}
            >
              {image ? (
                <ImageSubNavItem
                  label={label}
                  image={image}
                  origin={origin}
                  imageAltTexts={imageAltTexts}
                  link={link}
                  description={description}
                  date={date}
                  isNavMenuList={isNavMenuList}
                  navItemId={navItemId}
                />
              ) : (
                <StandardSubNavItem
                  label={label}
                  href={href}
                  desc={desc}
                  origin={origin}
                  logo={logo}
                  imageAltTexts={imageAltTexts}
                  isNavMenuList={isNavMenuList}
                  navItemId={navItemId}
                />
              )}
            </li>
          ),
        )}
      </ul>
      {canShowMoreLink && (
        <TrackedLink
          href={showAllHref}
          origin={origin}
          trackingObj={{ label: showAllLabel, href: showAllHref }}
          className={`${styles.showAll} ${
            subnavgroupitems.some(item => item.image) ? styles.addExtraPadding : ''
          }`}
          navItemId={navItemId}
        >
          <Typography variant="buttonLink2">{showAllLabel}</Typography>
        </TrackedLink>
      )}
    </>
  );
};
